var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsumersNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 53,
    viewBox: "0 0 79 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0102 51.2872C16.0567 49.5825 15.8548 47.8649 16.2133 46.1767C17.0864 42.0651 20.0848 39.3242 24.4681 38.5792C26.106 38.3006 27.7416 38.0058 29.3717 37.685C32.2627 37.1155 33.8178 34.3541 33.0324 31.229C32.5822 29.4371 31.6062 27.9237 30.4531 26.5238C28.5991 24.273 27.7015 21.7039 27.7434 18.8041C27.7748 16.6156 27.5663 14.4157 27.846 12.241C28.5043 7.12418 31.9818 3.39884 37.0361 2.2745C42.5302 1.05238 48.2492 4.0093 50.4145 9.18813C51.008 10.6073 51.2656 12.0945 51.2732 13.6193C51.2834 15.6399 51.2623 17.6608 51.2222 19.6809C51.1715 22.2307 50.2302 24.4523 48.6396 26.4212C47.8666 27.3782 47.1458 28.3735 46.619 29.4879C45.8373 31.1418 45.4351 32.8661 46.0886 34.6508C46.7168 36.3666 47.9873 37.3791 49.8011 37.7121C51.8148 38.0813 53.8404 38.4023 55.8335 38.862C59.7856 39.7737 62.7505 43.3723 62.9506 47.4036C63.0148 48.6971 63.036 49.9926 63.077 51.2872H16.0102Z",
    stroke: "url(#paint0_linear)",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77 46.6593C74.0615 46.6617 71.123 46.6451 68.1855 46.6816C67.5862 46.6891 67.3932 46.4594 67.3143 45.926C66.9177 43.2385 65.792 40.8298 64.0409 38.8136C61.8068 36.2414 58.947 34.6129 55.5221 34.0861C54.7645 33.97 54.0177 33.7821 53.2594 33.6722C52.9134 33.6223 52.8833 33.5139 52.9773 33.2084C53.3308 32.0576 53.1887 30.9267 52.7523 29.8268C52.5978 29.4366 52.6276 29.1368 52.88 28.7702C54.8404 25.9208 55.8522 22.7791 55.776 19.2963C55.7354 17.4433 55.7519 15.5887 55.7736 13.735C55.7944 11.9193 55.5598 10.1487 54.9105 8.44829C54.7368 7.99285 54.8353 7.79839 55.308 7.64849C60.4038 6.03263 66.3633 8.97175 67.3784 14.6733C67.8663 17.4119 67.797 20.2301 67.3221 22.9943C67.0384 24.6472 66.0914 25.9909 65.0817 27.2976C64.1198 28.542 63.3679 29.8864 63.2222 31.5203C63.0463 33.4907 64.1451 35.2156 66.004 35.6668C67.4929 36.0286 69.0052 36.3146 70.5217 36.5331C73.6884 36.9894 76.439 39.7082 76.8521 42.8785C76.8732 43.0414 76.8307 43.2223 77 43.3361V46.6593Z",
    stroke: "url(#paint1_linear)",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.76809 46.6205C5.37368 46.6205 3.97957 46.6232 2.58515 46.6178C2.33542 46.6169 2.00395 46.6914 2.01386 46.276C2.05023 44.6836 1.82213 43.0753 2.41476 41.5218C3.48581 38.7147 5.48127 37.0385 8.45642 36.514C9.84753 36.2691 11.2413 36.0334 12.6234 35.744C14.8028 35.2879 16.0653 33.2819 15.6479 31.1016C15.3068 29.3196 14.2874 27.9189 13.2167 26.5334C11.9752 24.9261 11.3345 23.1222 11.3673 21.0801C11.3928 19.4778 11.3676 17.8746 11.3733 16.2718C11.3883 11.9942 14.868 8.10069 19.1318 7.51576C20.6098 7.31301 22.039 7.39674 23.4719 7.77952C23.9969 7.91977 24.1697 8.0968 23.9726 8.66857C23.3538 10.4631 23.0641 12.3175 23.0921 14.2227C23.1173 15.9446 23.1026 17.6674 23.0963 19.3896C23.0833 22.7592 24.0315 25.8423 25.9085 28.6366C26.2331 29.1199 26.3091 29.5161 26.0897 30.0828C25.7168 31.046 25.5614 32.0681 25.913 33.0888C26.0486 33.4811 25.9524 33.6414 25.5341 33.7191C24.2641 33.9554 22.9761 34.1444 21.7394 34.5035C16.6973 35.9677 13.5487 39.3427 12.0002 44.2706C11.815 44.86 11.6621 45.4701 11.592 46.0816C11.5407 46.5323 11.3555 46.6271 10.951 46.6223C9.55692 46.6052 8.16251 46.6157 6.76809 46.6157V46.6205Z",
    stroke: "url(#paint2_linear)",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 25.8001,
    y1: -51.2327,
    x2: -37.6846,
    y2: 42.5741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0987965,
    stopColor: "#FFF0A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285019,
    stopColor: "#FFD700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796164,
    stopColor: "#FF41F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF33FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 57.7274,
    y1: -35.4256,
    x2: 3.01905,
    y2: 16.7594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0987965,
    stopColor: "#FFF0A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285019,
    stopColor: "#FFD700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796164,
    stopColor: "#FF41F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF33FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 7.04292,
    y1: -34.9441,
    x2: -47.3085,
    y2: 16.9704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0987965,
    stopColor: "#FFF0A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285019,
    stopColor: "#FFD700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796164,
    stopColor: "#FF41F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF33FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumersNew);
export default __webpack_public_path__ + "static/media/consumers-new.c2596a5336dda4cfca453048e20f0cb7.svg";
export { ForwardRef as ReactComponent };